import DealerError from './DealerError.js'

export class GetDealerError extends DealerError {}
